import React, { forwardRef } from "react";
import { Text, TextInput, View, TextInputProps } from "react-native";
import { Colors } from "../../constants/Colors";

interface TextFieldProps extends TextInputProps {
  label: string;
  error?: string;
}

const TextField = forwardRef<TextInput, TextFieldProps>(({ label, error, ...inputProps }, ref) => (
  <View style={styles.container}>
    <Text style={styles.label}>{label}</Text>
    <TextInput
      ref={ref}
      style={[styles.input, error && styles.inputError]}
      {...inputProps}
    />
    {!!error && <Text style={styles.errorText}>{error}</Text>}
  </View>
));

const styles = {
  container: {
    marginBottom: 10,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
    color: Colors.RedPallete.red,
    fontWeight: 'bold',
  },
  input: {
    borderColor: Colors.GrayPallete.lightGrayFour,
    borderWidth: 1,
    padding: 10,
    color: 'black',
  },
  inputError: {
    borderColor: Colors.RedPallete.red,
  },
  errorText: {
    color: Colors.RedPallete.red,
    fontSize: 12,
    marginTop: 4,
  },
};

export default React.memo(TextField);